module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "notedetail"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('h2', [_vm._v(_vm._s(this.Detail.title))])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "el-icon-time"
  }), _c('span', {
    staticClass: "rn-domainTime"
  }, [_vm._v(_vm._s(this.Detail.createdate))])]), _vm._v(" "), (this.Detail.newsPicture != null) ? _c('img', {
    attrs: {
      "src": this.Detail.newsPicture.serverFullPath
    }
  }) : _vm._e(), _vm._v(" "), _c('article', {
    domProps: {
      "innerHTML": _vm._s(this.Detail.content)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("食品安全知识详情")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633be7c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/note/notedetail.vue
// module id = 481
// module chunks = 1